import { PoolTicker, PoolTitle, TokenLogo, TopWrapper } from './parts'
import SwapBox from './SwapBox'
import { Box } from '../../shared_components/UI/Box'
import PoolAutomatedAudit from '../../shared_components/Pools/PoolAutomatedAudit'
import PoolBadges from '../../shared_components/Pools/PoolBadges'

import ProjectLinks from '../../shared_components/ProjectLinks'
import { IPool } from '../../types/reducerTypes'
import { useSelector } from 'react-redux'
import { selectCurrentProject } from '../../modules/missionControl/selectors'
import styled from 'styled-components'

const INFO_POINTS = [
  'Each raise on ZAP gives you a Whitelist amount. You can increase your Whitelist amount by completing missions.',
  'When a raise opens, you can purchase tokens up to your Whitelist amount.',
  'When a raise is oversubscribed, you’ll receive a refund plus tokens.',
]

const TopInfo = ({
  pool,
  calculatedMaxAllocation,
  topBlockRef,
}: {
  pool: IPool
  calculatedMaxAllocation: number | null
  topBlockRef: React.RefObject<HTMLDivElement>
}) => {
  const currentProject = useSelector(selectCurrentProject)
  if (!pool) return <></>
  const { name, ticker, audit, about, clientVerifications } = pool
  const logoUrl = about?.logo?.url ?? '/img/crowd-station.jpeg'
  return (
    <TopWrapper jsb pr ref={topBlockRef}>
      <Box dc g={16} className="core-block">
        <Box ac g={12}>
          <TokenLogo src={logoUrl} alt={`${name} logo`} />
          <PoolTicker>{ticker}</PoolTicker>
        </Box>
        <Box dc g={16}>
          <Box afe>
            <PoolTitle>{name}</PoolTitle>
          </Box>
          <Box ac g={16} fw>
            <PoolAutomatedAudit audit={audit} />
            <PoolBadges
              audit={audit}
              clientVerifications={clientVerifications}
            />
            <ProjectLinks project={currentProject} />
          </Box>
        </Box>
        <InfoPoints>
          {INFO_POINTS.map((point, i) => (
            <Box key={i} ac g={16}>
              <img src="/img/icons/custom-dot.svg" alt="dot" />
              <span>{point}</span>
            </Box>
          ))}
        </InfoPoints>
      </Box>
      <SwapBox
        pool={pool}
        calculatedMaxAllocation={calculatedMaxAllocation}
        calculatedTaxFreeAllocation={0}
        whitelistAllocation={0}
      />
    </TopWrapper>
  )
}

export default TopInfo

const InfoPoints = styled(Box)`
  flex-direction: column;
  gap: 16px;
  span {
    color: #fff;
    font-variant-numeric: ordinal;
    font-feature-settings: 'dlig' on, 'ss01' on, 'dnom' on;
    font-family: 'Space Grotesk';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: -0.64px;
  }
`
